export default __webpack_public_path__ + "static/media/2.36982765.jpg";